import APIService from './APIService'

const api = APIService()

export const fetchPushPublicKey = () => api.get('/me/push-subscriptions/public-key')

export const storePushSubscription = subscription =>
  api.post('/me/push-subscriptions', subscription)

export const deletePushSubscription = endpoint =>
  api.delete('/me/push-subscriptions', { endpoint })
